import { GROUP_LIST_TEACHER, GROUP_LIST_TEACHER_OK, GROUP_LIST_TEACHER_FAILED } from '../../constants/ActionTypes'

export default function (state = {}, action) {
  switch (action.type) {
    case GROUP_LIST_TEACHER: {
      return { ...state, result: null }
    }
    case GROUP_LIST_TEACHER_OK: {
      let { result } = action
      if (state.error) {
        delete state.error
      }
      return { ...state, result }
    }
    case GROUP_LIST_TEACHER_FAILED: {
      return { ...state, error: action.error }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/School/groupListTeacher.js